import { __rest } from "tslib";
import React from 'react';
import { useForkRef } from '../../hooks';
import { useTooltipVisible } from '../../hooks/private';
import { Hotkey } from '../Hotkey';
import { Popup } from '../Popup';
import { block } from '../utils/cn';
import './ActionTooltip.css';
const DEFAULT_PLACEMENT = ['bottom', 'top'];
const b = block('action-tooltip');
export function ActionTooltip(props) {
    const { placement = DEFAULT_PLACEMENT, title, hotkey, children, className, contentClassName, description, disabled = false, style, qa, id, disablePortal } = props, delayProps = __rest(props, ["placement", "title", "hotkey", "children", "className", "contentClassName", "description", "disabled", "style", "qa", "id", "disablePortal"]);
    const [anchorElement, setAnchorElement] = React.useState(null);
    const tooltipVisible = useTooltipVisible(anchorElement, delayProps);
    const renderPopup = () => {
        return (React.createElement(Popup, { id: id, disablePortal: disablePortal, role: "tooltip", className: b(null, className), style: style, open: tooltipVisible && !disabled, placement: placement, anchorRef: { current: anchorElement }, disableEscapeKeyDown: true, disableOutsideClick: true, disableLayer: true, qa: qa },
            React.createElement("div", { className: b('content', contentClassName) },
                React.createElement("div", { className: b('heading') },
                    React.createElement("div", { className: b('title') }, title),
                    hotkey && React.createElement(Hotkey, { view: "dark", value: hotkey, className: b('hotkey') })),
                description && React.createElement("div", { className: b('description') }, description))));
    };
    const child = React.Children.only(children);
    const childRef = child.ref;
    const ref = useForkRef(setAnchorElement, childRef);
    return (React.createElement(React.Fragment, null,
        React.cloneElement(child, { ref }),
        anchorElement ? renderPopup() : null));
}
